/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
// Returns version number of current release
// Version number placeholder is replaced by the precise release version number at the time of
// release
// Relevant configuration located in semantic-release configuration file
export const getRemoteManagedUiVersion = (): string => {
    return "1.40.6"; // Version number placeholder
};
